import styled, { keyframes, css } from 'styled-components';

// Animation keyframes
const rotate360 = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Theme-aware spinner component
export const Spinner = styled.div`
  display: inline-block;
  border: ${(props) => props.width || 2}px solid #007bff;
  border-bottom-color: transparent;
  border-radius: 50%;
  background: transparent;
  width: ${(props) => props.size || 24}px;
  height: ${(props) => props.size || 24}px;
  transform: translateZ(0);
  animation: ${rotate360} ${(props) => props.duration || '1s'} linear infinite;
  
  /* Apply theme styles only when not using blank skin */
  ${({ theme, size, width, duration }) => theme.name !== 'blank' && css`
    border-width: ${width || theme.spinner.width || '2px'};
    border-color: ${theme.spinner.borderColor || theme.colors.primary || '#007bff'};
    border-bottom-color: transparent;
    width: ${size || theme.spinner.size || '24px'};
    height: ${size || theme.spinner.size || '24px'};
    animation-duration: ${duration || theme.spinner.duration || '1s'};
  `}
`;

export default Spinner;

